import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { errMsg } from "@/lib/api";
import AuthShell from "./AuthShell";
import { t } from "@/i18n";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError(t("resetPassword.8_caracteres_minimum"));
    if (password !== confirm) return setError(t("resetPassword.les_mots_de_passe_ne_correspondent_pas"));
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("resetPassword.nouveau_mot_de_passe")} subtitle={t("resetPassword.choisissez_un_mot_de_passe_securise")}>
      {done ? (
        <div className="space-y-4" data-testid="reset-success">
          <div className="rounded-xl border bg-emerald-500/10 p-5 text-sm">
            <CheckCircle2 className="mb-2 h-5 w-5 text-emerald-500" />{t("resetPassword.votre_mot_de_passe_a_ete_mis_a_jour")}
          </div>
          <Button asChild className="w-full" data-testid="reset-go-login-btn"><Link to="/login">{t("common.se_connecter")}</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {!token && <p className="text-sm text-rose-500">{t("resetPassword.lien_invalide_jeton_manquant")}</p>}
          <div className="space-y-2">
            <Label htmlFor="pw">{t("resetPassword.nouveau_mot_de_passe")}</Label>
            <Input id="pw" type="password" required data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pw2">{t("resetPassword.confirmer")}</Label>
            <Input id="pw2" type="password" required data-testid="reset-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          {error && <p className="text-sm text-rose-500" data-testid="reset-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading || !token} data-testid="reset-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{t("resetPassword.mettre_a_jour")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
